<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/carhartt/products/*', { eager: true });

useHead({});

const products = [
	{
		title: 'Gilliam Vest', 
		src: imagesGlob['../../images/brands/carhartt/products/gilliam-vest.jpg'].default
	},
	{
		title: 'Foundry Series 20” Duffel', 
		src: imagesGlob['../../images/brands/carhartt/products/foundry-series-20-duffel.jpg'].default
	},
	{
		title: 'Textured 1/2 Zip Fleece Jacket', 
		src: imagesGlob['../../images/brands/carhartt/products/textured-12zip-fleece-jacket.jpg'].default
	},
	{
		title: 'Midweight Hooded Sweatshirt', 
		src: imagesGlob['../../images/brands/carhartt/products/midweight-hooded-sweatshirt.jpg'].default
	},
	{
		title: 'Watch Cap 2.0', 
		src: imagesGlob['../../images/brands/carhartt/products/watch-cap-20.jpg'].default
	},
	{
		title: 'Flexfit 110 Mesh Back Cap', 
		src: imagesGlob['../../images/brands/carhartt/products/flexfit-110-mesh-back-cap.jpg'].default
	},
	{
		title: '20 Can Backpack Cooler', 
		src: imagesGlob['../../images/brands/carhartt/products/20-can-backpack-cooler.jpg'].default
	},
	{
		title: 'Duck Traditional Coat', 
		src: imagesGlob['../../images/brands/carhartt/products/duck-traditional-coat.jpg'].default
	},
	{
		title: 'Midweight Crewneck Sweatshirt', 
		src: imagesGlob['../../images/brands/carhartt/products/midweight-crewneck-sweatshirt.jpg'].default
	},

]
</script>

<template lang="pug">
.page.page--brand.carhartt
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/carhartt/logo.png')
				h1 Custom Carhartt
			.image
				img(src='@static/images/brands/carhartt/hero.webp' alt="Man wearing Carhartt overalls, jacket, and beanie stands outdoors in a snowy landscape, showcasing the brand’s durable, cold-weather workwear.")
	section.section.section--subhero
		.section__content
			.copy
				h3 TRUE TO THIS
				p Forged in Detroit and trusted for over 130 years, Custom Carhartt by Swagger delivers gear that works as hard as the people who wear it. Built for real life with heavy-duty fabrics and triple-stitched strength, this legendary brand blends utility with iconic style. From busy worksites to everyday errands, Carhartt brings dependable performance and unmistakable authenticity to every moment.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src" :alt="`Custom Carhartt ${product.title}`")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="carhartt")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/carhartt/banner.webp' alt="Close-up of two Carhartt denim Jeans with visible stitching and Carhartt logo tags, overlaid with the Carhartt and Cotton Blue Jeans Go Green™ denim recycling partnership logos.")
			.section__content
				.copy
					h2 LEGACY THAT LASTS
					p Carhartt’s rugged construction, signature duck canvas, and iconic silhouettes set the gold standard for durability. Built to perform and endure, each piece carries a legacy of grit and timeless style. With deep American roots and initiatives like Carhartt Reworked, including the Blue Jeans Go Green™ partnership, Carhartt extends gear life and diverts thousands of pounds of denim from landfills.
		
		section.section.section--foot
			.bg
			.section__content

</template>

<style></style>